import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import Settings from './Settings';
import Auth from './Auth';
import Common from './Common';
import permission from './permission';
import ClientDetail from './ClientDetail';
import TabReducer from './TabIssueReducer/TabReducer';
import AccountAddress from './AccountAddress';
import User from './User';
import AccountFilter from './AccountFilter';
import diamond from './diamond';
import { history } from 'util/history';
import TermsDetail from './TermsDetail';
import LoaderReducer from './LoaderReducer';
import UserFilter from './UserFilter';
import FilterReducer from './FilterReducer';

const reducers = combineReducers({
  router: connectRouter(history),
  settings: Settings,
  auth: Auth,
  commonData: Common,
  permission: permission,
  client: ClientDetail,
  tab: TabReducer,
  accountAddress: AccountAddress,
  user: User,
  accountFilter: AccountFilter,
  userFilter: UserFilter,
  diamondData: diamond,
  termsDetail: TermsDetail,
  loader: LoaderReducer,
  filter: FilterReducer,
});

export default reducers;
